

function PyromancyTier18DesignTemplate() {
    return (
        <div>
            <hr className="HorizontalLineBlue" />
            <b className="AbilityHeader animationcolorWhiteOrangeFlashing">DESIGN INSIGHTS</b>
            <hr className="HorizontalLineBlue" />
            <div className="animationFadeIn">
                This talent allows a Pyromancer to completely reshape the surface of the immediate
                area into a fiery hell, or ration out their destructive mayhem over three separate encounters.
            </div>
            <p>
                <b className="AbilityHeaderSmall">DO OVERLAPPING MAGMA SURFACES STACK?</b>
                <div className="animationFadeIn">
                    No, only the first instance of lava in a 5ft square applies.
                </div>
            </p>
            <p>
                <b className="AbilityHeaderSmall">THEMING</b>
                <div className="animationFadeIn">
                    Hey kids, have you ever wanted to burn an entire city down?
                    <br />
                    Well now you can!
                    <p />
                    It can not be overstated how biblically terrifying this ability
                    can be, especially now as the Pyromancer has conquered the Wildfire and Greater Searing Heat Talents.
                    <p />
                    <i>You really have become the walking Inferno itself.</i>
                </div>
            </p>
            <br />
        </div>
    )
}

export { PyromancyTier18DesignTemplate };